import React from 'react';

import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import Selection from '../Selection';
import EmptyList from './EmptyList';

import {
    selectCountUserSelections,
    selectUserSelections,
} from '~Betslip/selectors/userSelectionsSelectors';

const SelectionsList = () => {
    const userSelectionsCounter = useSelector(selectCountUserSelections);
    const selections = useSelector(selectUserSelections);

    const renderSelections = selections.map(({ id }) =>
        <Selection
            key={id}
            id={id}
        />);

    return (
        <>
            {
                userSelectionsCounter
                    ? renderSelections
                    : <EmptyList />
            }
        </>
    );
};

export default SelectionsList;
